"use client";

import Link from "next/link";
import { useUser } from "@clerk/nextjs";
import { Button } from "@/components/ui/button";

/**
 * Session-aware secondary CTA for the home hero.
 *
 * Same reasoning as ./PublicAuthNav.tsx: a client leaf using `useUser()`
 * keeps ../page.tsx and ../layout.tsx on the static/SSR-fast path (this is
 * the public SEO surface) instead of pulling `auth()` into their render.
 *
 * Renders "Sign up" for visitors and "Go to my portal" once signed in —
 * pointing at the same neutral /portal handler the header uses, which
 * resolves the role server-side via roleHome(). Before Clerk reports
 * loaded, the signed-out label is rendered so the CTA never flashes empty
 * and is present for crawlers, which never execute Clerk.
 */
export function HeroCta() {
  const { isLoaded, isSignedIn } = useUser();

  const signedIn = isLoaded && isSignedIn;

  return (
    <Button asChild size="lg" variant="outline">
      <Link href={signedIn ? "/portal" : "/sign-up"}>
        {signedIn ? "Go to my portal" : "Sign up"}
      </Link>
    </Button>
  );
}
